import React from "react";
import backBtnSVG from "../resources/svg/back_btn.svg";

const BackBtn = ({ onClick }) => {
  return (
    <img
      src={backBtnSVG}
      alt="back btn"
      className="arrowBackBtn"
      onClick={() => onClick()}
      role="button"
      tabIndex="0"
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") onClick();
      }}
    />
  );
};

export default BackBtn;
